import { Link } from "react-router-dom";
import { GraduationCap, Clock } from "lucide-react";
import { Badge } from "./ui/badge";
import { useLang } from "../context/LanguageContext";

export const DoctorCard = ({ doctor }) => {
  const { lang, t } = useLang();
  return (
    <div data-testid={`doctor-card-${doctor.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden hover:-translate-y-1 hover:shadow-md transition-[transform,box-shadow]">
      <div className="h-64 overflow-hidden bg-slate-100">
        <img src={doctor.photo_url || undefined} alt={doctor.name} className="w-full h-full object-cover object-top" loading="lazy" />
      </div>
      <div className="p-6">
        <h3 className="font-heading text-lg font-semibold text-slate-900">{doctor.name}</h3>
        <p className="text-sm text-emerald-600 font-medium mb-3">{doctor.specialization}</p>
        <div className="space-y-2 text-sm text-slate-500 mb-4">
          <div className="flex items-center gap-2"><GraduationCap className="w-4 h-4 text-slate-400" /> {doctor.qualifications}</div>
          <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-slate-400" /> {doctor.experience_years} {t("doctors.exp")}</div>
        </div>
        <p className="text-sm text-slate-500 leading-relaxed mb-4">{lang === "ms" ? doctor.bio_ms : doctor.bio_en}</p>
        <div className="flex flex-wrap gap-1.5 mb-5">
          {(doctor.languages || []).map((l) => <Badge key={l} variant="secondary" className="bg-slate-100 text-slate-600 font-normal">{l}</Badge>)}
        </div>
        <Link to={`/booking?doctor=${doctor.id}`} data-testid={`doctor-book-${doctor.id}`}
          className="inline-flex items-center text-sm font-semibold text-primary hover:text-blue-800 transition-colors">
          {t("doctors.book")} →
        </Link>
      </div>
    </div>
  );
};
